import { defaultsDeep } from 'lodash';

const promiseCacheKey = 'uiUserSettings-promise';
const cacheKey = 'userSettingsService.uiUserSettings.v3';

export default class UserSettingsService {
/** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    cacheService,
    promiseCacheService,
    $q
  ) {
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.cacheService = cacheService;
    this.promiseCacheService = promiseCacheService;
    this.$q = $q;
  }

  getUserSettings() {
    var cachedValue = this.cacheService.get(cacheKey);
    
    if (cachedValue) {
      return this.$q.when(defaultsDeep({}, cachedValue));
    }

    return this.#getUserSettingsFromServer()
      .then((response) => {
        return defaultsDeep({}, response.data.settings);
      });
  }

  saveUserSettings(newSettings) {
    var url = this.serviceBaseUri + 'uiUserSettings';

    var data = { settings: newSettings };

    return this.getUserSettings().then((old) => {
      //only save if there has been a change
      if (!angular.equals(old, newSettings)) {
        return this.$http.post(url, data)
          .then((response) => {
            this.cacheService.set(cacheKey, response.data.settings);
            return angular.copy(response.data.settings);
          });
      } else {
        return this.$q.when(newSettings);
      }
    });

  }

  removeUserUISettingsFromCache() {
    this.cacheService.remove(cacheKey);
  }

  #getUserSettingsFromServer() {
    var url = this.serviceBaseUri + 'uiUserSettings';
    return this.promiseCacheService.getCallWithCachedPromise(promiseCacheKey, url, 0,
      (response) => {
        this.cacheService.set(cacheKey, response.data.settings);
      });
  }
}